import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Collapse, ListItemButton, ListItemText } from "@mui/material";
import React, { useState } from "react";
import OptionsList from "./OptionsList";
import { MenuOrderItemSummary } from "./types";

interface MenuItemDialogListItemProps {
  menuOrderItemSummary: MenuOrderItemSummary;
}

const MenuItemDialogListItem = ({ menuOrderItemSummary }: MenuItemDialogListItemProps) => {
  const [open, setOpen] = useState(false);
  const { menuItem, amount, choices } = menuOrderItemSummary;
  const primaryText = menuItem.servingName ? `${menuItem.name} (${menuItem.servingName})` : menuItem.name;
  const secondaryText = `${amount} ${menuItem.servingName || "serving(s)"}`;

  return (
    <>
      <ListItemButton key={menuItem.id} onClick={() => setOpen(!open)}>
        <ListItemText primary={primaryText} secondary={secondaryText} />
        {choices && (open ? <ExpandLess /> : <ExpandMore />)}
      </ListItemButton>
      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit>
        <OptionsList choices={choices} />
      </Collapse>
    </>
  );
};

export default MenuItemDialogListItem;
